import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';

const Landing = () => {
    return (
        <section>
            <Helmet>
                <title>Evaluationz: Case Studies</title>
                {(window.location.pathname === '/case-studies') &&
                <script src="//evaluationz.mykampaign.com/focus/12.js" type="text/javascript" charset="utf-8"
                        async="async"></script>
                }
                <meta name="description" content="Read about the dangers averted by timely verifications from Evaluationz" />
                <meta name="keywords" content="address verification, criminal verification, drug panel testing, employment verification, education verification, employee verification, user verification, vendor verification, Identity check, Social Media Check, Reference check, Drug test, Digital verification, passport verification, credit check, API Integration, Reduced TAT, Real time verification, verification Specialist, NASCOM empanelled, credit score check, Evaluationz, Evaluationz India Pvt. Ltd., Verification India, AI, Artificial Intelligence, BlueG, Coporate verification, IT Verification, Ites Verification, Banking and Financial Services Industry Verification, Automative verification, eCommerce verification, healthcare verification, rental verificaion, matrimonial verification, hyperlocal verification, blue collar verification, white collar verification" />
                <meta property="og:description" content="Read about the dangers averted by timely verifications from Evaluationz" />
                <meta property="og:url" content="https://www.evaluationz.com/case-studies" />
                <meta property="og:image" content="https://www.evaluationz.com/images/favicon.jpg" />
                <meta property="og:image:secure_url" content="https://www.evaluationz.com/images/favicon.jpg" />
                <meta name="twitter:image" content="https://www.evaluationz.com/images/favicon.jpg" />
            </Helmet>

            <div className="about-section bg-white pt-100 mt-5 pb-4">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 pb-30">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="font-weight-bolder mb-4">
                                        <span className="text-white bg-red px-3 py-2 rounded-3">Case Study 1</span>
                                    </h1>
                                    <h1 className="text-black font-weight-bolder">Non-disclosure of criminal charges</h1>
                                </div>

                                <div className="about-content">
                                    <p className="text-black font-weight-bold mb-0">Overview:</p>
                                    <p className="text-black font-weight-normal">A leading microfinance company needed to fill the position of Manager – Cash Collection. The role had a direct impact on the
                                        finances of the company and demanded the highest integrity.</p>

                                    <p className="text-black font-weight-bold mb-0">Context:</p>
                                    <p className="text-black font-weight-normal">The candidate was shortlisted and an offer was imminent. The background verification had to be done on very tight deadlines.</p>

                                    <p className="text-black font-weight-bold mb-0">Solution:</p>
                                    <p className="text-black font-weight-normal">Evaluationz conducted the verification using the BlueG platform, utilizing the componentized features.</p>

                                    <p className="text-black font-weight-bold mb-0">Results:</p>
                                    <p className="text-black font-weight-normal mb-1">When the results came back, it was found that the candidate was a respondent in a case filed under the Code of Criminal
                                        Procedure and IPC. He was charged for cheating and the offense of criminal intimidation. His address also showed up as
                                        unverified.</p>
                                    <p className="text-black font-weight-normal">
                                        The results came back in time to avert a negative outcome.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-white pb-4">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 pb-30">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="font-weight-bolder mb-4">
                                        <span className="text-white bg-blue px-3 py-2 rounded-3">Case Study 2</span>
                                    </h1>
                                    <h1 className="text-black font-weight-bolder">Employment and reference falsification</h1>
                                </div>

                                <div className="about-content">
                                    <p className="text-black font-weight-bold mb-0">Overview:</p>
                                    <p className="text-black font-weight-normal">A finance company was looking to fill the position of a Senior Manager with the requisite experience in the finance industry
                                        across large companies and microfinance organizations.</p>

                                    <p className="text-black font-weight-bold mb-0">Context:</p>
                                    <p className="text-black font-weight-normal">The potential candidate claimed employment in a large BFSI company, with 1 year of prior experience in a microfinance
                                        company, and 4 years in a large company before that. He provided an experience letter and references from previous
                                        employers.</p>

                                    <p className="text-black font-weight-bold mb-0">Solution:</p>
                                    <p className="text-black font-weight-normal">Evaluationz conducted the verification using digital and manual methods.</p>

                                    <p className="text-black font-weight-bold mb-0">Results:</p>
                                    <p className="text-black font-weight-normal mb-1">Upon detailed verification with the earlier employer, it was found that the experience letter was completely forged. Also, the
                                        ‘earlier manager’ who was cited as a reference (and who ‘testified’ over a phone call) was a bogus/decoy reference, was just an
                                        acquaintance of the employee, and was never associated with the earlier employer.</p>
                                    <p className="text-black font-weight-normal">
                                        On detection of the falsification, the hiring company was able to avoid hiring a dishonest candidate.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-white pb-4">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 pb-30">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="font-weight-bolder mb-4">
                                        <span className="text-white bg-red px-3 py-2 rounded-3">Case Study 3</span>
                                    </h1>
                                    <h1 className="text-black font-weight-bolder">Integrity and Salary fabrication</h1>
                                </div>

                                <div className="about-content">
                                    <p className="text-black font-weight-bold mb-0">Overview:</p>
                                    <p className="text-black font-weight-normal">The company was in the process of hiring a salesperson in the IT space</p>

                                    <p className="text-black font-weight-bold mb-0">Context:</p>
                                    <p className="text-black font-weight-normal">The candidate submitted an appointment letter from the previous employer showing a salary of Rs. 8 lakhs. He negotiated a
                                        salary of Rs. 10 lakhs from the hiring company.</p>

                                    <p className="text-black font-weight-bold mb-0">Solution:</p>
                                    <p className="text-black font-weight-normal">Evaluationz conducted the verification using digital and manual methods.</p>

                                    <p className="text-black font-weight-bold mb-0">Results:</p>
                                    <p className="text-black font-weight-normal mb-1">Upon detailed verification –the previous employer confirmed there was an Integrity and Disciplinary issue of the candidate. </p>
                                    <p className="text-black font-weight-normal">
                                        It was also found that the salary details on the appointment letter had been doctored to show the higher salary, while the
                                        actual salary was only Rs. 5.5 lakhs. So, the falsification of salary enabled him to get an 81% increment!
                                    </p>
                                    <p className="text-black font-weight-normal">
                                        By spending a limited amount of money on the BGV, the hiring company saved a few lakhs in the overpayment of salary and
                                        avoided hiring a dishonest employee.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-white pb-4">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 pb-30">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="font-weight-bolder mb-4">
                                        <span className="text-white bg-blue px-3 py-2 rounded-3">Case Study 4</span>
                                    </h1>
                                    <h1 className="text-black font-weight-bolder">FNF Pending and Performance issue</h1>
                                </div>

                                <div className="about-content">
                                    <p className="text-black font-weight-bold mb-0">Overview:</p>
                                    <p className="text-black font-weight-normal">Candidate was being evaluated for the position of Analyst in an IT company</p>

                                    <p className="text-black font-weight-bold mb-0">Context:</p>
                                    <p className="text-black font-weight-normal">The candidate claimed to have worked as an analyst for a large IT company and had provided an employment letter from the
                                        previous company.</p>

                                    <p className="text-black font-weight-bold mb-0">Solution:</p>
                                    <p className="text-black font-weight-normal">Evaluationz conducted the verification using digital and manual methods.</p>

                                    <p className="text-black font-weight-bold mb-0">Results:</p>
                                    <p className="text-black font-weight-normal mb-1">Verification with the previous employer brought to light that the candidate had been put on PIP twice for performance issues.
                                        The candidate had also been warned multiple times for short hour logging, unplanned leaves, and low productivity during
                                        remote working.</p>
                                    <p className="text-black font-weight-normal">
                                        The employer confirmed that the candidate’s FNF (full and final) settlement had not been completed for more than 3 months.
                                    </p>
                                    <p className="text-black font-weight-normal">
                                        The BGV helped the hiring company steer clear of hiring the wrong candidate.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-white pb-4">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 pb-30">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="font-weight-bolder mb-4">
                                        <span className="text-white bg-red px-3 py-2 rounded-3">Case Study 5</span>
                                    </h1>
                                    <h1 className="text-black font-weight-bolder">Processing large volume of BGC cases from multiple locations</h1>
                                </div>

                                <div className="about-content">
                                    <p className="text-black font-weight-bold mb-0">Overview:</p>
                                    <p className="text-black font-weight-normal">Leading IT/Blue Collar company was struggling in managing BGC initiation because of a wide range of projects and
                                        demography - day-to-day cases transaction from more than 30 locations and 50+ different projects.</p>

                                    <p className="text-black font-weight-bold mb-0">Context:</p>
                                    <p className="text-black font-weight-normal">Though the process was managed online, there were delays. There was also a high level of dependency on people and chances
                                        of cases being missed, large size attachments, and so on when cases were initiated on email.</p>

                                    <p className="text-black font-weight-bold mb-0">Solution:</p>
                                    <p className="text-black font-weight-normal">It was recommended to integrate Evaluationz online tool with the company’s HRMS (Human Resource Management System)
                                        application.</p>
                                    <p className="text-black font-weight-normal">Evaluationz pioneered a real-time API reference architecture to ensure API calls were processed as close to real-time as
                                        possible. For example, when the candidate was joining and filling forms in the HRMS portal, cases were getting pushed to BGC
                                        online tool in real-time.</p>
                                    <p className="text-black font-weight-normal">When the case got completed, reports were pushed to the client's HRMS tool with colour codes.</p>

                                    <p className="text-black font-weight-bold mb-0">Results:</p>
                                    <p className="text-black font-weight-normal mb-1">API management solutions helped the client reduce manual intervention and helped them to locate cases in real-time. TAT
                                        was slashed by 5days. It also led to 100% control of data leakage.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Landing;
